var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTerramatic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.78674 4.66097C9.90372 4.71617 9.97835 4.8339 9.97835 4.96325V10.1852C9.97835 10.4304 9.72318 10.5921 9.50147 10.4875L0.191607 6.09449C0.0746296 6.03929 0 5.92156 0 5.79221V0.570268C0 0.325113 0.255164 0.163371 0.476876 0.267989L9.78674 4.66097Z",
    fill: "#008440"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5226 0.226372C19.7444 0.121226 20.0001 0.28296 20.0001 0.528386V5.7073C20.0001 5.836 19.9262 5.95327 19.8101 6.00881L10.457 10.4838C10.2352 10.5899 9.97852 10.4282 9.97852 10.1823V4.96304C9.97852 4.83392 10.0529 4.71635 10.1696 4.66103L19.5226 0.226372Z",
    fill: "#28A864"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78871 15.5894C9.90488 15.6449 9.97884 15.7622 9.97884 15.891V21.555C9.97884 21.5749 9.95794 21.588 9.94 21.5793L5.28562 19.3139C5.17063 19.2579 5.09766 19.1412 5.09766 19.0133V13.8778C5.09766 13.632 5.35418 13.4702 5.57601 13.5763L9.78871 15.5894Z",
    fill: "#008440"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3792 13.5386C14.6012 13.4305 14.8597 13.5922 14.8597 13.8391V18.9704C14.8597 19.0983 14.7868 19.2149 14.6718 19.2709L10.459 21.3213C10.237 21.4294 9.97852 21.2677 9.97852 21.0208V15.8895C9.97852 15.7617 10.0515 15.645 10.1665 15.589L14.3792 13.5386Z",
    fill: "#28A864"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2712 2.03906H9.68606C9.31687 2.03906 9.01758 2.33835 9.01758 2.70755V23.9758C9.01758 24.345 9.31687 24.6443 9.68606 24.6443H10.2712C10.6404 24.6443 10.9397 24.345 10.9397 23.9758V2.70755C10.9397 2.33835 10.6404 2.03906 10.2712 2.03906Z",
    fill: "#008440"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerramatic);
export default __webpack_public_path__ + "static/media/terramatic.18a3440788812b17ca3f133a1f352e67.svg";
export { ForwardRef as ReactComponent };